import load_maps from '../app/map';
import 'slick-carousel/slick/slick.min.js';

export default {
    init() {
        // JavaScript to be fired on all pages
        jQuery(window).on('load', () => {
            load_maps();
        });

        jQuery(window).load(function() {
            var container = '.post-list';
            var button = '.load-more a';
            jQuery(document).on('click', button, function (e) {
                e.preventDefault();
                var $this = jQuery(e.currentTarget);
                $this.addClass('disabled');
                jQuery.get($this.attr('href'), function (data) {
                    var data_to_add = jQuery(container + ' > div', data);
                    jQuery(container).append(data_to_add);
                    jQuery(document).trigger('pagination_load', [data_to_add]);
                    if (jQuery(button, data).length <= 1) {
                        $this.remove();
                    } else {
                        $this.removeClass('disabled');
                        $this.attr('href', jQuery(button, data).attr('href'));
                    }
                });
            });
        });

        /* $('.navigation a').on('click', function() {
            if ($(window).width() < 1000) {
               $('.navigation').collapse('toggle');
            }
        }); */

        if ( $( '.vertical-slider' ).length ) {
            $('.vertical-slider').slick({
                dots: false,
                infinite: false,
                speed: 1000,
                autoplay: false,
                fade: true,
                prevArrow: '<button type="button" class="slick-prev"><</button>',
                nextArrow: '<button type="button" class="slick-next">></button>',
            });
        }
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js